import styled from "@emotion/styled";
import { createTheme } from "@mui/material/styles";
import { ReactMFE } from "@tpd-web-common-libs/nodejs-library";
import { Styles } from "@tpd-web-common-libs/nodejs-library";

const containerDivBorderWidth = 1;
export const ContainerDiv = styled.div`
  display: flex;
  width: 100%;
  height: 54px;
  border: ${containerDivBorderWidth}px solid #d8d8d8;
  ${Styles.BreakpointsUtils.mobileOnly(`
    border: none;
  `)}
`;

export const HeaderTabPrivates = styled.div`
  width: calc(100% * 3 / 24);
  height: 100%;
  margin-left: calc(100% * 1 / 24);

  ${Styles.BreakpointsUtils.mobileOnly(`
    width: calc(100% * 12 / 24);
    margin-left: 0;
  `)}

  ${Styles.BreakpointsUtils.tabletOnly(`
    width: calc(100% * 8 / 24);
    margin-left: 0;
  `)}
`;

export const HeaderTabCompanies = styled.div`
  width: calc(100% * 3 / 24);
  height: 100%;

  ${Styles.BreakpointsUtils.mobileOnly(`
    width: calc(100% * 12 / 24);
  `)}

  ${Styles.BreakpointsUtils.tabletOnly(`
    width: calc(100% * 8 / 24);
  `)}
`;

export const HeaderTab = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  background-color: #f1f1f1;
  color: #6b6b6b;
  border-bottom: 4px solid #f1f1f1;
  cursor: pointer;
  //box-sizing: border-box;

  &.header-tabs-active {
    border-color: ${Styles.Themes.UnipolColors.blueOne};
    ${Styles.TouchpointUtils.touchpointThemeOnly(
      (touchpoint: any) => `
      border-color: ${touchpoint.mainColor};
      `
    )}
    cursor: default;
    background-color: #fff;
  }
`;

export const HeaderTabLink = styled(ReactMFE.Link)`
  color: ${Styles.Themes.UnipolColors.blueSix};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
    color: ${touchpoint.darkQuaternaryColor};
  `
  )}

  &:hover {
    color: ${Styles.Themes.UnipolColors.blueOne};
    ${Styles.TouchpointUtils.touchpointThemeOnly(
      (touchpoint: any) => `
    color: ${touchpoint.mainColor};
  `
    )}
  }

  display: flex;
  align-items: center;
  text-decoration: none;
  font-size: 16px;
  text-transform: uppercase;
  font-family: Unipol Medium;

  ${Styles.BreakpointsUtils.mobileAndTabletOnly(`
    font-family: Unipol;
  `)}
`;

export const SiteSelection = styled.div`
  width: calc(100% * 7 / 24);
  margin-left: calc(100% * 10 / 24);
  height: 100%;

  ${Styles.BreakpointsUtils.mobileAndTabletOnly(`
    display: none;
  `)}
`;

export const DropdownAndMiniLogoWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const DropdownSitesWrapper = styled.div`
  display: inline-block;
`;

export const DropdownSiteDiv = styled.div`
  display: flex;
  align-items: center;
  color: #9b9b9b;
  cursor: pointer;
  font-family: Unipol;
  font-size: 12px;
  text-transform: uppercase;
`;

export const menuTheme = createTheme({
  components: {
    MuiMenu: {
      styleOverrides: {
        paper: {
          "&.MuiMenu-paper": {
            transition: "none",
            top: "0px !important",
            background: "transparent",
            border: "1px solid #0f3250",
            borderRadius: 0,
            borderTop: 0,
            boxShadow: "none",
            minWidth: "250px",
          },
        },
        list: {
          padding: 0,
        },
      },
    },
  },
});

export const DropdownIcon = styled.i`
  position: relative;
  bottom: 2px;
  font-size: 30px;
`;

export const DropdownSiteLi = styled.li`
  padding: 15px;
  text-align: right;
  white-space: nowrap;
  cursor: pointer;
  background: white;
  font-size: 14px;

  &:not(:first-of-type):hover {
    background-color: ${Styles.Themes.UnipolColors.blueTen};
    ${Styles.TouchpointUtils.touchpointThemeOnly(
      (touchpoint: any) => `
        background-color: ${touchpoint.whitishColor};
      `
    )}
  }

  &:first-of-type {
    background: transparent;
    opacity: 0;
  }

  a {
    color: ${Styles.Themes.UnipolColors.blueOne};
    ${Styles.TouchpointUtils.touchpointThemeOnly(
      (touchpoint: any) => `
        color: ${touchpoint.mainColor};
      `
    )}
    font-family: Unipol;
    font-weight: 100;
    text-transform: uppercase;
    text-decoration: none;
  }
`;
